import type { IconProps } from './IconProps';

export const WarningCircleSolidIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 30}
    height={props.height ?? 30}
    {...props}
  >
    <path
      d="M15.0001 9.6665V14.9998M15.0001 20.3332H15.0134M28.3334 14.9998C28.3334 22.3636 22.3639 28.3332 15.0001 28.3332C7.63628 28.3332 1.66675 22.3636 1.66675 14.9998C1.66675 7.63604 7.63628 1.6665 15.0001 1.6665C22.3639 1.6665 28.3334 7.63604 28.3334 14.9998Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
